<template>
  <div class="slide fp-noscroll" :style="slide.backgroundColor ? `background-color: ${slide.backgroundColor};` : 'transparent;'">
    <Loading v-if="isLoading"></Loading>
    <div class="zoom" :class="{horizontal: !slide.vertical || slide.vertical === 'false'}" :style="`animation-duration: ${animationDuration}s; background-image: url(${slide.photo});`">
      <pinch-zoom ref="pinch" class="pinch" disableZoomControl="never" listeners="touch" :wheel="false" overflow="hidden">
        <img :src="slide.photo" alt="">
      </pinch-zoom>
    </div>
    <img :src="slide.photo" alt="" v-show="false" @load="onImgLoad">
    <app-footer :footer="slide.footnote" :details="slide.details" v-show="!zoomedIn"></app-footer>
  </div>
</template>

<script>
import AppFooter from './Footer';
import Loading from './Loading.vue';
import loaderLoaderMixin from '../mixins/loader';
import PinchZoom from 'vue-pinch-zoom'

export default {
  props: ["slide", "photo", "details", "footnote"],
  mixins: [loaderLoaderMixin],
  components: {AppFooter, Loading, PinchZoom},
  methods: {
    onImgLoad() {
        this.isLoading = false;
        // adjust animation speed
        let img = new Image();
        
        img.src = this.slide.photo;
        const width = img.width;
        const height = img.height;
        const ratio = width / height;
        console.log('zoom image ratio', ratio);
    }
  },
  data() {
    return {
         zoomedIn: false,
         animationDuration: 10
      }
  },
  mounted () {
      this.$watch('$refs.pinch.isZoomedIn', (val) => {
        this.zoomedIn = val;
      })
   },
   watch: {
    zoomedIn(val) {
      this.$emit('setAllowScrolling', !val);
    }
   }
};
</script>

<style scoped>
.zoom {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: center;
  background-size: 100vw;
  animation: animatedBackground 10s linear infinite alternate;
}
.zoom.slow {
  animation: animatedBackground 16s linear infinite alternate;
}
.zoom.horizontal {
  background-size: auto 100vh;
  animation: animatedBackgroundHorizontal 10s linear infinite alternate;
}
.zoom.horizontal.slow {
  animation: animatedBackgroundHorizontal 16s linear infinite alternate;
}
@keyframes animatedBackground {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 0 100%;
  }
}
@keyframes animatedBackgroundHorizontal {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 100% 0;
  }
}
@media (min-width: 576px) {
  .pinch {
    display: none;
    margin: auto 0;
  }
}
@media (max-width: 576px) {
  .zoom {
    background-image: none !important;
  }
  .pinch {
    height: 100vh;
  }
}
</style>